import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-e989d0a8")

_pushScopeId("data-v-e989d0a8")
const _hoisted_1 = { class: "modal-content" }
const _hoisted_2 = { class: "p-text-center" }
const _hoisted_3 = /*#__PURE__*/_createVNode("i", { class: "material-icons icon-alert margin-bottom-20" }, "warning_amber", -1)
const _hoisted_4 = { class: "block mb-5 color-white" }
const _hoisted_5 = { class: "block mb-5 color-white" }
const _hoisted_6 = { class: "flexbox-row p-jc-between" }
_popScopeId()

import { client } from '@/api/client-v2';
import { User } from '@/generated-sources/anagrafica-api';
import { store } from '@/store/store';
import { computed, ref } from 'vue';
import { useI18n } from 'vue-i18n';
import UiButton from '../ui/UiButton.vue';


export default _defineComponent({
  props: {
    user: { type: null, required: false },
    isBanned: { type: Boolean, required: false },
    userId: { type: String, required: true }
  } as unknown as undefined,
  emits: ['user-updated'],
  setup(__props: {
  user?: User;
  isBanned?: boolean;
  userId: string;
}, { emit }) {

const props = __props
const { t } = useI18n();



const isVisible = ref(false);



/* COMPUTED */
const myClubId = computed(() => {
  return store.getters.getMyClub.club_id;
});

const banUser = async () => {
  try {
    await client.banUser({ userId: props.userId, clubId: myClubId.value })
  } catch (error) {
    console.error('Error banning user:', error);
  } finally {
    isVisible.value = false;
    emit('user-updated');
  }
}

const unbanUser = async () => {
  try {
    await client.unbanUser({ userId: props.userId, clubId: myClubId.value })
  } catch (error) {
    console.error('Error unbanning user:', error);
  } finally {
    isVisible.value = false;
    emit('user-updated');
  }
}

return (_ctx: any,_cache: any) => {
  const _component_DumbModal = _resolveComponent("DumbModal")!

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode(UiButton, {
      onClick: _cache[1] || (_cache[1] = ($event: any) => (isVisible.value = true)),
      size: "sm",
      variant: props.isBanned ? 'primary' : 'danger',
      "is-text": true
    }, {
      default: _withId(() => [
        _createTextVNode(_toDisplayString(props.isBanned ? _unref(t)('unblock') : _unref(t)('block')), 1)
      ]),
      _: 1
    }, 8, ["variant"]),
    (isVisible.value)
      ? (_openBlock(), _createBlock(_component_DumbModal, {
          key: 0,
          title: props.isBanned ? _unref(t)('unblock_user') : _unref(t)('block_user'),
          onHide: _cache[3] || (_cache[3] = () => isVisible.value = false)
        }, {
          footer: _withId(() => [
            _createVNode("div", _hoisted_6, [
              _createVNode(UiButton, {
                label: _unref(t)('abort'),
                variant: 'secondary',
                onClick: _cache[2] || (_cache[2] = ($event: any) => (isVisible.value = false)),
                size: "lg"
              }, null, 8, ["label"]),
              (props.isBanned)
                ? (_openBlock(), _createBlock(UiButton, {
                    key: 0,
                    label: _unref(t)('confirm'),
                    variant: 'primary',
                    size: "lg",
                    onClick: unbanUser
                  }, null, 8, ["label"]))
                : (_openBlock(), _createBlock(UiButton, {
                    key: 1,
                    label: _unref(t)('confirm'),
                    variant: 'primary',
                    size: "lg",
                    onClick: banUser
                  }, null, 8, ["label"]))
            ])
          ]),
          default: _withId(() => [
            _createVNode("div", _hoisted_1, [
              _createVNode("div", _hoisted_2, [
                _hoisted_3,
                (props.isBanned)
                  ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                      _createVNode("span", _hoisted_4, _toDisplayString(_unref(t)('attention')), 1),
                      _createVNode("p", {
                        class: "color-white",
                        innerHTML: _unref(t)('unban_user_main_text', { name: `${props.user?.nome} ${props.user?.cognome}` })
                      }, null, 8, ["innerHTML"])
                    ], 64))
                  : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                      _createVNode("span", _hoisted_5, _toDisplayString(_unref(t)('attention')), 1),
                      _createVNode("p", {
                        class: "color-white",
                        innerHTML: _unref(t)('ban_user_main_text', { name: `${props.user?.nome} ${props.user?.cognome}` })
                      }, null, 8, ["innerHTML"])
                    ], 64))
              ])
            ])
          ]),
          _: 1
        }, 8, ["title"]))
      : _createCommentVNode("", true)
  ], 64))
}
}

})